// 美术馆API
import request from '@/utils/request'
// 微服务
const prefix = '/yslt-server-admin'
/**
 * 获取官方美术馆详情
 * @param {galleryId} 美术馆id
 * @returns
 */
export const getGalleryInfo = galleryId => {
  return request({
    url: prefix + '/api/v1/appGallery/getGalleryDetail',
    params: {
      galleryId
    }
  })
}
/**
 * 获取美术馆参展艺术家列表
 * @param {galleryId} 美术馆id
 * @returns
 */
export const getGalleryArtList = galleryId => {
  return request({
    url: prefix + '/api/v1/appGallery/queryGalleryArtList',
    params: {
      galleryId
    }
  })
}
/**
 * 获取美术馆参展作品列表
 * @param {galleryId} 美术馆id
 * @returns
 */
export const getGalleryWorkeList = galleryId => {
  return request({
    url: prefix + '/api/v1/appGallery/queryGalleryWorksList',
    params: {
      galleryId
    }
  })
}
/**
 * 获取美术馆第三方
 * @param {galleryId} 美术馆id
 * @returns
 */
export const getGalleryApp = galleryId => {
  return request({
    url: prefix + '/api/v1/appGallery/queryGalleryAppList',
    params: {
      galleryId
    }
  })
}
